import React from 'react';
import Header from '../../components/Header';
import Hero from '../../components/Hero';
import Problem from '../../components/Problem';
import Features from '../../components/Features';
import Segments from '../../components/Segments';
import Steps from '../../components/Steps';
import Benefits from '../../components/Benefits';
import Pricing from '../../components/Pricing';
import FAQ from '../../components/FAQ';
import LeadForm from '../../components/LeadForm';
import Testimonials from '../../components/Testimonials';
import Footer from '../../components/Footer';
import CookieConsent from '../../components/CookieConsent';

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Problem />
        <Features />
        <Segments />
        <Steps />
        <Benefits />
        <Pricing />
        <LeadForm />
        <FAQ />
        <Testimonials />
      </main>
      <Footer />
      <a 
        href="https://wa.me/5545991439499" 
        className="whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Falar conosco no WhatsApp"
      >
        <svg 
          viewBox="0 0 24 24" 
          width="32" 
          height="32" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-11.4 8.5 8.5 0 0 1 4.7 1.4L22 3l-1.5 5.5Z"></path>
        </svg>
      </a>
      <CookieConsent />
    </>
  );
};

export default Home;
